<template>
    <div>
        <!-- 作答记录 -->
        <div class="inner">
            <div class="data-market-row title">
                <span>项目名称</span>
                <span>项目状态</span>
                <span>报酬</span>
                <span>审核结果</span>
            </div>
            <div class="data-market-row" v-for="item in list" :key="item.shortUrl">
                <span>{{ item.surveyName }}</span>
                <span>{{ get_surveyStatus_text(item.surveyStatus) }}</span>
                <span>￥{{ item.answerAward }}</span>
                <span>{{get_answerStatus_text(item.answerStatus)}}</span>
            </div>
        </div>
        <div class="table_base_fenye">
            <el-pagination
                background
                class="pagination"
                layout="prev, pager, next"
                :page-size="10"
                :current-page="pageIndex"
                :total="total"
                @current-change="onChangePage">
            </el-pagination>
        </div>
    </div>   
</template>

<style lang="scss" scoped>
.data-market-row{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 1200px;
    height: 82px;
    background: #fff;
    border-radius: 10px;
    font-size: 16px;
    padding: 0 50px;
    margin-bottom: 15px;
    span:nth-child(1){
        width: 396px;
        margin-right: 120px;
    }
    span:nth-child(2){
        width: 150px;
        margin-right: 50px;
    }
    span:nth-child(3){
        flex: 1;
    }
    span:nth-child(4){
        flex: 1;
        text-align: center;
    }
}
.data-market-row.title{
    height: 60px;
    margin-top: 50px;
    margin-bottom: 30px;
}
.home_dataMarket_zhuanfa_dialog{
    /deep/ .el-dialog__body {
        padding: 10px 20px 30px;
    }
    /deep/ .zhuanfa_dialog_bg{
        padding: 0 30px;
        .zhuanfa_now_title{
            padding: 15px 0;
            color: #333;
            font-weight: 650;
            font-size: 18px;
        }
        .zhuanfa_now_content{
            position: relative;
            display: flex;
            align-items: center;
            .home_zhuanfa_right_btn{
                width: 92px;
                position: absolute;
            }
            .copy_link{
                right: 0;
                top: -5px;
            }
            .download_qr{
                right: 0;
                top: 130px;
            }
        }
    }
}
.table_base_fenye{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 40px 0;
}
</style>

<script>
import { SurveyStatus, AnswerStatus } from '@/config/enum'
export default {
    props: {
        list: Array,
        total: Number,
    },
    data(){
        return {
            pageSize: 10,
            pageIndex: 1
        }
    },
    computed: {
        surveyStatusEnum(){
            return this.$enum.getEnumKeyValue(SurveyStatus)
        },
        answerStatusEnum(){
            return this.$enum.getEnumValueDesc(AnswerStatus)
        },
    },
    methods: {
        onChangePage(index){
            this.pageIndex = parseInt(index)
            this.$emit('init', this.tab, this.pageIndex)
        },
        get_surveyStatus_text(surveyStatus){
            if(surveyStatus === this.surveyStatusEnum.CREATED){
                return '新建'
            }
            if(surveyStatus === this.surveyStatusEnum.PAUSED ||
            surveyStatus === this.surveyStatusEnum.END ||
            surveyStatus === this.surveyStatusEnum.FINISHED){
                return '已完成'
            }
            if(surveyStatus === this.surveyStatusEnum.DISPENSED || 
            surveyStatus === this.surveyStatusEnum.ANSWERED ||
            surveyStatus === this.surveyStatusEnum.NO_PERMISSION ||
            surveyStatus === this.surveyStatusEnum.FULL){
                return '发布中'
            }
            return '未知'
        },
        get_answerStatus_text(answerStatus){
            return this.answerStatusEnum[answerStatus]
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/data-market/record-table.vue